export default "__VITE_ASSET__c639ded9__"